import { useEffect } from 'react'
import { AttributionControl, type ControlPosition, useMap } from 'react-map-gl/mapbox'

interface Props {
  position?: ControlPosition
  compact?: boolean
}

function openAttributionLinksInNewTab(container: HTMLElement) {
  const attributionLinks = container.querySelectorAll<HTMLAnchorElement>('.mapboxgl-ctrl-attrib a')

  attributionLinks.forEach((link) => {
    link.target = '_blank'
    link.rel = 'noopener nofollow'
  })
}

export function MapboxAttributionControl({ position = 'bottom-right', compact = true }: Props) {
  const { current: mapRef } = useMap()

  useEffect(() => {
    const map = mapRef?.getMap()
    if (!map) {
      return
    }

    const updateAttributionLinks = () => openAttributionLinksInNewTab(map.getContainer())

    updateAttributionLinks()
    map.on('styledata', updateAttributionLinks)

    return () => {
      map.off('styledata', updateAttributionLinks)
    }
  }, [mapRef])

  return <AttributionControl compact={compact} position={position} />
}
